import React from 'react';

import sendKM from '@ott/utility-km';

import FadeIn from 'src/components/elements/FadeIn';

import styles from './MobileAppBanner.scss';

const S3_URL = 'https://static.solartrip.com/images/';
const MobileAppButtons = ({ downloadLink }: { downloadLink: string }) => {
  const handleDownloadApp = () => {
    window.open(downloadLink, '_blank');
  };

  return (
    <FadeIn delay={0.6} className={styles.storesContainer}>
      <div
        role="presentation"
        onClick={() => {
          sendKM('GOOGLEPLAYBUTTON_CLICK', {
            obj: {
              source: window.location.pathname,
            },
          });
          handleDownloadApp();
        }}
      >
        <img
          className={styles.appButton}
          src={`${S3_URL}app_landing/download_block/appstore.svg`}
          alt="appstore"
        />
      </div>
      <div
        role="presentation"
        onClick={() => {
          sendKM('APPSTOREBUTTON_CLICK', {
            obj: {
              source: window.location.pathname,
            },
          });
          handleDownloadApp();
        }}
      >
        <img
          className={styles.appButton}
          src={`${S3_URL}app_landing/download_block/google_play.svg`}
          alt="google-play"
        />
      </div>
    </FadeIn>
  );
};

export default MobileAppButtons;
